export enum InvoiceStatus {
  DRAFT = 'DRAFT',
  FINALIZED = 'FINALIZED',
  VOIDED = 'VOIDED',
}

export enum InvoicePaymentStatus {
  PAID = 'PAID',
  UNPAID = 'UNPAID',
}

export enum CollectionMethod {
  CHARGE_ON_CHECKOUT = 'CHARGE_ON_CHECKOUT',
  AUTO_CHARGE = 'AUTO_CHARGE',
  OUT_OF_BAND = 'OUT_OF_BAND',
}
